import React, {ReactElement} from 'react';
import {Summary} from 'ui/components/Summary';

export const SummaryView = (): ReactElement => {
  return <Summary />;
};
